import { Button, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { redirectToCentralizedLogin } from '@/auth/silentRefresh';
import { StandaloneFrame } from '@/shell/StandaloneFrame';

/**
 * The signed-out screen. After Delete now (TMMAPP-0119 §E 26c) `?deleted=erased|erasing` says the
 * data is gone (or finishing), and that the same email can sign up again: the sign-in itself stays.
 */
export function SignedOut() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const deleted = params.get('deleted');
  const erased = deleted === 'erased' || deleted === 'erasing';
  return (
    <StandaloneFrame>
      <Typography variant="h1" gutterBottom>
        {t('auth.signedOutTitle')}
      </Typography>
      {erased ? (
        <>
          <Typography variant="body1" sx={{ mb: 1 }} data-deleted={deleted}>
            {deleted === 'erased' ? t('auth.dataDeleted') : t('auth.dataDeleting')}
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            {t('auth.signUpAgain')}
          </Typography>
        </>
      ) : (
        <Typography variant="body1" sx={{ mb: 3 }}>
          {t('auth.signedOutBody')}
        </Typography>
      )}
      <Button variant="contained" onClick={() => redirectToCentralizedLogin('/')}>
        {t('auth.signInAgain')}
      </Button>
    </StandaloneFrame>
  );
}
